import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

function SlideUpDown({ appear, children }) {
  return (
    <CSSTransitionGroup
      transitionName="animation__slide-up"
      transitionAppear={appear}
      transitionAppearTimeout={350}
      transitionEnterTimeout={350}
      transitionLeaveTimeout={420}
    >
      {children}
    </CSSTransitionGroup>
  )
}

export default SlideUpDown
